import { MarketplaceSubGroup } from "@shared/types";

export const buildMarketPlaceGroupEvent = (
  marketplaceGroup: MarketplaceSubGroup,
  pagePosition: number
) => {
  return {
    marketplaceGroupId: marketplaceGroup.group_id,
    marketplaceGroupAverageRating: marketplaceGroup.avg_stars || -1,
    marketplaceGroupDiscountOffered: marketplaceGroup.discount,
    marketplaceGroupOffersFreeTrial: marketplaceGroup.has_free_trial,
    marketplaceGroupReviewsCount: marketplaceGroup.num_of_reviewers,
    marketplaceGroupDollarSignsCount: marketplaceGroup.price_number,
    marketplaceGroupPagePosition: pagePosition,
  };
};

export const getMixpanelToken = (): string | undefined => {
  const token = import.meta.env.VITE_APP_MIXPANEL_PROJECT_TOKEN?.trim();
  return token && !token.endsWith("-placeholder") ? token : undefined;
};
